export default __webpack_public_path__ + "img/dYYMEyuz.85f08e46.svg";